<script lang="ts">
	import { Icon } from "$lib/components/atoms/Icon";
	import { clickOutside } from "$lib/events/clickOutside";
	import { closeModal } from "$lib/utils/modals";
	import type { CourseModel, SessionModel } from "@24hbs/utils";
	import { CourseScheduleSelector } from "../Schedule";

  export let session: SessionModel;
  export let enableSessionSelection = false;
  export let sessionOptions: {[idSession: string]: SessionModel};
  export let selectedSession: CourseModel | SessionModel;
  export let hasVatFree: boolean;
  export let showExpandButton: boolean;
  export let onScheduleChange: (e: CustomEvent<{ value: SessionModel }>) => void;
  export let isOpen: boolean = false;

  const handleOnScheduleChange = (e: CustomEvent<{ value: SessionModel }>) => {
    onScheduleChange(e);
    closeModal();
  };
</script>

{#if isOpen}
  <div
    class="course-select-modal"
    role="dialog"
    aria-labelledby="Scopri le date di partenza"
  >
    <div
      class="modal-dialog"
      use:clickOutside
      on:click_outside={closeModal}
    >
      <div class="modal-header">
        <div>
          <div class="modal-subtitle">Scopri le date di partenza</div>
          <h2 class="modal-title">Quando iniziare</h2>
        </div>
        <div>
          <button
            class="close"
            aria-label="Chiudi"
            on:click={closeModal}
          >
            <Icon icon="close" />
          </button>
        </div>
      </div>
      <div class="modal-body">
        <CourseScheduleSelector
          on:change={handleOnScheduleChange}
          {showExpandButton}
          sessions={sessionOptions}
          bind:selectedSession
          bind:hasVatFree
        />
      </div>
    </div>
  </div>
{/if}

<style lang="scss" scoped>
  .course-select-modal {
    @apply fixed inset-0;
    @apply flex flex-col;
    @apply z-modal;
    @apply md:items-center md:justify-center;
  }

  .modal-dialog {
    @apply bg-gray-50;
    @apply w-full h-full;
    @apply flex flex-col;
    @apply md:bg-white;
    @apply md:w-10/12 md:max-w-6xl;
    @apply md:h-[90vh] md:max-h-screen-md;
  }

  .modal-header {
    @apply p-4 pr-3;
    @apply md:p-6;
		@apply flex items-start justify-between;
    @apply bg-white;
		@apply mb-2;
  }

  .modal-subtitle {
    @apply hidden md:inline-block;
    @apply text-gray-600;
    @apply font-semibold uppercase tracking-widest;
    @apply mb-2;
    @apply md:order-2;
  }

  .modal-title {
    @apply font-serif font-medium;
    @apply text-lg md:text-6xl;
    @apply md:order-3;
  }

  .close {
    @apply ml-auto;
    @apply transition-opacity duration-200;
    @apply hover:opacity-75;
  }

  .modal-body {
    @apply flex-grow;
    @apply overflow-y-auto md:overflow-y-scroll;
    @apply p-4 pb-0;
    @apply mt-4;
    @apply md:p-6 md:pb-0;
    @apply md:mt-12 md:mb-6;
    @apply md:pr-12 md:mr-6;

    @screen md {
      &::-webkit-scrollbar {
        @apply appearance-none;
        @apply w-1;
      }
      &::-webkit-scrollbar-track {
        @apply bg-gray-900 bg-opacity-30;
        @apply rounded-full;
      }
      &::-webkit-scrollbar-thumb {
        @apply rounded-full;
        @apply bg-gray-900;
      }
    }
  }
</style>